import React, { useEffect, useState } from "react";
import { ModalBody, Spinner, Modal } from "reactstrap";
import superagent from "superagent";
import Cookies from "universal-cookie";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { base_url } from "../../utils/constants";
import { getAccountInformation } from "../account/actions";
import { Button } from "react-bootstrap";

function PlanToBasicModel(props) {
  const { isOpen, onClosed, message, isFree, onClick, setShow } = props;
  const [showLoader, setShowLoader] = useState(false);
  const cookie = new Cookies();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAccountInformation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleExitSubscription = () => {
    setShowLoader(true);
    superagent
      .post(`${base_url}exit-subscription`)
      .set("accept", "application/json")
      .set("Authorization", cookie.get("user_token"))
      .end((_err, res) => {
        if (res?.body?.status) {
          toast.success(res.body.message);
          window.location.replace("/my-account?scrollto=subscription");
        }
      });
  };

  return (
    <Modal isOpen={isOpen} onClosed={onClosed} className="basicModel" aria-labelledby="contained-modal-title-vcenter" centered size="sm">
      <ModalBody>
        <h4>{message}</h4>
        <div className="mt-3 text-end">
          <Button
            onClick={() => {
              onClosed();
              if (isFree) {
                setShow(false);
              }
            }}
            variant="outline-danger"
          >
            Close
          </Button>
          {showLoader ? (
            <div className="d-inline-flex align-items-center">
              <p className="mb-0 text-primary fw-bolder me-2 ml-2">Loading...</p>
              <Spinner animation="border" size="sm" />
            </div>
          ) : (
            <Button
              Button
              className="ml-2"
              size="lg"
              onClick={() => {
                if (isFree) {
                  setShowLoader(true);
                  onClick();
                } else {
                  handleExitSubscription();
                }
              }}
              variant="success"
            >
              Yes
            </Button>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
}

export default PlanToBasicModel;
